(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBanner(root) {
    var track = root.querySelector('[data-banner-track]');
    if (!track) return;
    var slides = root.querySelectorAll('[data-banner-slide]');
    var dots = root.querySelectorAll('[data-banner-dot]');
    if (slides.length < 2) return; // nothing to rotate

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var index = 0, timer, scrollTimer;

    function setActive() {
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === index);
        d.setAttribute('aria-selected', di === index ? 'true' : 'false');
      });
    }
    function goTo(i, smooth) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * index, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive();
    }
    function next() {
      if (index + 1 >= slides.length) { goTo(0, false); } // instant rewind to first
      else { goTo(index + 1, true); }
    }
    function start() { if (autoplay) { stop(); timer = setInterval(next, speed); } }
    function stop() { clearInterval(timer); }

    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        index = Math.round(track.scrollLeft / track.clientWidth);
        setActive();
      }, 90);
    }, { passive: true });

    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { goTo(di); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    track.addEventListener('pointerdown', stop);
    track.addEventListener('pointerup', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    window.addEventListener('resize', function () {
      track.scrollTo({ left: track.clientWidth * index, behavior: 'auto' });
    });

    setActive();
    start();
  }
  function init() { document.querySelectorAll('[data-banner]').forEach(initBanner); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  var root, moneyFormat, cartUrl, changeUrl, addUrl;
  var shipGoal = 0, bundleQty = 0, bundleCode = '', bundlePrice = 0, bundleGate = true, bundleLabel = '';
  var qualIds = [], qualType = '', qualVariant = '';
  var lastFocus = null;
  var state = null;
  var recUrl = '', upsellMode = 'auto', upsellLimit = 6;
  var lastAnchor = null, recCache = null, staticHtml = null;

  /* ---- money ---- */
  function fmt(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var int = parts[0];
    var last3 = int.slice(-3);
    var rest = int.slice(0, -3);
    if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
    var withDec = last3 + '.' + parts[1];
    var noDec = last3;
    if (moneyFormat) {
      if (/amount_no_decimals/.test(moneyFormat)) {
        return moneyFormat.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec);
      }
      if (/\{\{\s*amount\s*\}\}/.test(moneyFormat)) {
        return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, withDec);
      }
    }
    return '₹' + withDec;
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---- qualifying items ---- */
  function qualifies(item) {
    // Pack filter is a veto, checked before anything else: a multi-pack must
    // never count toward the bundle even though its product is in the
    // qualifying collection. Keeps this in step with a discount scoped to
    // single-pack variants — if the two disagree, the drawer promises an offer
    // that checkout then refuses.
    if (qualVariant) {
      var vt = (item.variant_title || '').toLowerCase();
      if (vt.indexOf(qualVariant) === -1) return false;
    }
    if (!qualIds.length && !qualType) return true;
    if (qualIds.length && qualIds.indexOf(String(item.product_id)) !== -1) return true;
    if (qualType && item.product_type &&
        item.product_type.toLowerCase() === qualType.toLowerCase()) return true;
    return false;
  }
  function qualCount(cart) {
    var n = 0;
    (cart.items || []).forEach(function (i) { if (qualifies(i)) n += i.quantity; });
    return n;
  }

  /* ---- unlock celebration ---- */
  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  // Persisted so the moment still fires when the drawer opens on a fresh page
  // load right after an add — but never re-fires for an already-unlocked cart.
  function wasUnlocked(key) {
    try { return sessionStorage.getItem('havmi_unlocked_' + key) === '1'; } catch (e) { return false; }
  }
  function storeUnlocked(key, val) {
    try { sessionStorage.setItem('havmi_unlocked_' + key, val ? '1' : '0'); } catch (e) {}
  }
  function celebrate(el) {
    if (!el || reduceMotion()) return;
    el.classList.remove('is-just-unlocked');
    void el.offsetWidth;
    el.classList.add('is-just-unlocked');

    var burst = document.createElement('span');
    burst.className = 'cd__confetti';
    var colors = ['#4A6741', '#8FB37A', '#E8C46A', '#E07A5F', '#6FA8DC'];
    for (var i = 0; i < 16; i++) {
      var p = document.createElement('i');
      var angle = (Math.PI * 2 * i) / 16 + (Math.random() * 0.5 - 0.25);
      var dist = 40 + Math.random() * 40;
      p.style.setProperty('--dx', (Math.cos(angle) * dist).toFixed(1) + 'px');
      p.style.setProperty('--dy', (Math.sin(angle) * dist * 0.75).toFixed(1) + 'px');
      p.style.setProperty('--rot', Math.round(Math.random() * 540 - 270) + 'deg');
      p.style.background = colors[i % colors.length];
      p.style.animationDelay = Math.round(Math.random() * 90) + 'ms';
      burst.appendChild(p);
    }
    el.appendChild(burst);
    setTimeout(function () {
      if (burst.parentNode) burst.parentNode.removeChild(burst);
      el.classList.remove('is-just-unlocked');
    }, 1250);
  }
  function checkUnlock(key, isUnlocked, el) {
    if (isUnlocked && !wasUnlocked(key)) celebrate(el);
    storeUnlocked(key, isUnlocked);
  }

  /* ---- rendering ---- */
  function renderRewards(cart) {
    var total = cart.total_price || 0;

    var bundle = root.querySelector('[data-cd-bundle]');
    if (bundle && bundleQty > 0) {
      var have = qualCount(cart);
      var need = Math.max(0, bundleQty - have);
      var unlocked = need === 0 && have > 0;

      // Don't advertise an offer to a cart holding none of the eligible products.
      bundle.hidden = (bundleGate && have === 0);
      bundle.classList.toggle('is-unlocked', unlocked);

      var title = bundle.querySelector('[data-cd-bundle-title]');
      var msg = bundle.querySelector('[data-cd-bundle-msg]');
      var fill = bundle.querySelector('[data-cd-bundle-fill]');
      var count = bundle.querySelector('[data-cd-bundle-count]');
      var dots = bundle.querySelector('[data-cd-dots]');

      if (title) title.textContent = unlocked ? 'Offer Applied!' : '';
      if (msg) {
        // A discount CODE cannot touch the cart — Shopify only applies it at
        // checkout, so the cart total stays full and we have to say so. An
        // AUTOMATIC discount is already in cart.total_price, so promising it
        // "at checkout" would read as a second, missing discount. Keying off
        // the code setting means clearing that field flips this text too.
        msg.innerHTML = unlocked
          ? esc(bundleLabel) + (bundleCode ? ' — discount at checkout' : ' — discount applied')
          : 'Add <b>' + need + ' more</b> to unlock <b>' + esc(bundleLabel) + '</b>';
      }
      if (fill) fill.style.width = Math.min(100, (have / bundleQty) * 100) + '%';
      if (count) count.textContent = Math.min(have, bundleQty) + ' of ' + bundleQty + ' items added';
      if (dots) {
        var h = '';
        for (var s = 1; s <= bundleQty; s++) {
          h += '<i class="' + (have >= s ? 'is-done' : '') + '">' + s + '</i>';
        }
        dots.innerHTML = h;
      }
      if (!bundle.hidden) checkUnlock('bundle', unlocked, bundle);
    }

    var ship = root.querySelector('[data-cd-ship]');
    if (ship && shipGoal > 0) {
      var shipOk = total >= shipGoal;
      var sFill = ship.querySelector('[data-cd-ship-fill]');
      var sMsg = ship.querySelector('[data-cd-ship-msg]');
      if (sFill) sFill.style.width = Math.min(100, (total / shipGoal) * 100) + '%';
      ship.classList.toggle('is-unlocked', shipOk);
      if (sMsg) {
        sMsg.innerHTML = shipOk
          ? "🎉 Woohoo! You've unlocked <b>FREE shipping</b>"
          : 'Add <b>' + fmt(shipGoal - total) + '</b> more for FREE shipping';
      }
      checkUnlock('ship', shipOk, ship);
    }

    var wrapEl = root.querySelector('[data-cd-rewards]');
    if (wrapEl) {
      var anyVisible = false;
      Array.prototype.forEach.call(wrapEl.children, function (c) { if (!c.hidden) anyVisible = true; });
      var hasItems = !!(cart.items && cart.items.length);
      wrapEl.style.display = (hasItems && anyVisible) ? '' : 'none';
    }
  }

  function renderItems(cart) {
    var wrap = root.querySelector('[data-cd-items]');
    var empty = root.querySelector('[data-cd-empty]');
    var foot = root.querySelector('[data-cd-foot]');
    if (!wrap) return;

    if (!cart.items || !cart.items.length) {
      wrap.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    var html = '';
    cart.items.forEach(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_180x180$1$2') : '';
      var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<span class="cd-item__tag">' + esc(item.variant_title) + '</span>' : '';
      var offer = (qualifies(item) && bundleQty > 0)
        ? '<span class="cd-item__tag cd-item__tag--offer">Offer item</span>' : '';
      var unitWas = item.original_price > item.final_price
        ? '<s>' + fmt(item.original_price) + '</s>' : '';

      html +=
        '<div class="cd-item" data-line="' + (i + 1) + '">' +
          '<button type="button" class="cd-item__remove" data-cd-remove aria-label="Remove">' +
            '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>' +
          '</button>' +
          '<div class="cd-item__top">' +
            '<span class="cd-item__media">' +
              (img ? '<img src="' + img + '" alt="' + esc(item.product_title) + '" loading="lazy" width="76" height="76">' : '') +
            '</span>' +
            '<div>' +
              '<a class="cd-item__title" href="' + item.url + '">' + esc(item.product_title) + '</a>' +
              '<div class="cd-item__unit">' + unitWas + fmt(item.final_price) + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="cd-item__bottom">' +
            '<span class="cd-item__tags">' + variant + offer + '</span>' +
            '<span class="cd-item__qty">' +
              '<button type="button" data-cd-minus aria-label="Decrease quantity">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-cd-plus aria-label="Increase quantity">+</button>' +
            '</span>' +
            '<span class="cd-item__line">' + fmt(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>';
    });
    wrap.innerHTML = html;
  }

  function cartProductIds(cart) {
    var map = {};
    (cart.items || []).forEach(function (i) { map[String(i.product_id)] = true; });
    return map;
  }

  // Fixed list from the chosen collection, minus anything already in the cart.
  function renderUpsellStatic(cart) {
    var box = root.querySelector('[data-cd-upsell]');
    var row = box && box.querySelector('.cd__upsell-row');
    if (!box || !row) return;
    if (staticHtml !== null && row.getAttribute('data-dynamic') === 'true') {
      row.innerHTML = staticHtml;
      row.removeAttribute('data-dynamic');
    }
    var inCart = cartProductIds(cart);
    var shown = 0;
    row.querySelectorAll('[data-cd-up]').forEach(function (card) {
      var hide = !!inCart[card.getAttribute('data-product-id')];
      card.hidden = hide;
      if (!hide) shown++;
    });
    box.hidden = shown === 0 || !(cart.items && cart.items.length);
  }

  // Every add-on adds straight to the cart — no hop to the product page.
  // Multi-variant products use their first available variant (e.g. Pack of 1),
  // and the price shown is THAT variant's, so the strike-through can't come
  // from a different pack size than the one being added.
  function upsellCard(p) {
    var img = p.featured_image
      ? p.featured_image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_180x180$1$2') : '';

    var variants = p.variants || [];
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].available !== false) { v = variants[i]; break; }
    }
    if (!v) v = variants[0];
    if (!v) return '';                       // nothing addable — skip the card

    var price = (v.price != null) ? v.price : p.price;
    var compare = (v.compare_at_price != null) ? v.compare_at_price : p.compare_at_price;
    var was = (compare && compare > price) ? '<s>' + fmt(compare) + '</s>' : '';

    return '<div class="cd-up" data-cd-up data-product-id="' + p.id + '">' +
        '<a class="cd-up__media" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" width="90" height="90" loading="lazy">' : '') +
        '</a>' +
        '<a class="cd-up__title" href="' + p.url + '">' + esc(p.title) + '</a>' +
        '<span class="cd-up__price">' + was + fmt(price) + '</span>' +
        '<button type="button" class="cd-up__add" data-cd-up-add data-variant-id="' + v.id + '">ADD</button>' +
      '</div>';
  }

  // Shopify's own recommendations, anchored to the highest-value item in the cart.
  function renderUpsell(cart) {
    var box = root.querySelector('[data-cd-upsell]');
    if (!box) return;
    var items = cart.items || [];
    if (!items.length) { box.hidden = true; return; }
    if (upsellMode !== 'auto' || !recUrl) { renderUpsellStatic(cart); return; }

    var anchor = items.slice().sort(function (a, b) {
      return b.final_line_price - a.final_line_price;
    })[0];
    var key = String(anchor.product_id);

    // Only refetch when the anchor changes — not on every quantity tweak.
    if (key === lastAnchor && recCache) { paintRecs(cart, recCache); return; }
    lastAnchor = key;

    function fetchRecs(intent) {
      return fetch(recUrl + '.json?product_id=' + key + '&limit=10' +
                   (intent ? '&intent=' + intent : ''), { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { return (d && d.products) || []; })
        .catch(function () { return []; });
    }

    // Complementary = curated in Search & Discovery; related = algorithmic.
    fetchRecs('complementary')
      .then(function (list) { return list.length ? list : fetchRecs('related'); })
      .then(function (list) {
        recCache = list;
        paintRecs(cart, list);
      })
      .catch(function () { renderUpsellStatic(cart); });
  }

  function paintRecs(cart, list) {
    var box = root.querySelector('[data-cd-upsell]');
    var row = box && box.querySelector('.cd__upsell-row');
    if (!box || !row) return;

    var inCart = cartProductIds(cart);
    var picks = (list || []).filter(function (p) {
      return p && p.available !== false && !inCart[String(p.id)];
    }).slice(0, upsellLimit);

    if (!picks.length) { renderUpsellStatic(cart); return; }

    row.innerHTML = picks.map(upsellCard).join('');
    row.setAttribute('data-dynamic', 'true');
    box.hidden = false;
  }

  function renderFoot(cart) {
    var sub = root.querySelector('[data-cd-subtotal]');
    if (sub) sub.textContent = fmt(cart.total_price || 0);

    var saved = 0;
    (cart.items || []).forEach(function (i) {
      if (i.original_line_price > i.final_line_price) saved += i.original_line_price - i.final_line_price;
    });
    var save = root.querySelector('[data-cd-saving]');
    if (save) {
      if (saved > 0) { save.textContent = "🎉 You're saving " + fmt(saved); save.hidden = false; }
      else { save.hidden = true; }
    }

    // Route checkout through the discount URL once the bundle is unlocked.
    var btn = root.querySelector('[data-cd-checkout]');
    if (btn) {
      var unlocked = bundleQty > 0 && qualCount(cart) >= bundleQty;
      btn.setAttribute('href', (unlocked && bundleCode)
        ? '/discount/' + encodeURIComponent(bundleCode) + '?redirect=/checkout'
        : '/checkout');
    }

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    var c = root.querySelector('[data-cd-count]');
    if (c) c.textContent = cart.item_count;
  }

  function render(cart) {
    state = cart;
    renderItems(cart);
    renderRewards(cart);
    renderUpsell(cart);
    renderFoot(cart);
  }

  /* ---- data ---- */
  function refresh() {
    if (!bind()) return Promise.resolve();
    return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; })
      .catch(function () {});
  }
  function changeLine(line, quantity, itemEl) {
    if (itemEl) itemEl.classList.add('is-busy');
    return fetch(changeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () { if (itemEl) itemEl.classList.remove('is-busy'); });
  }
  function addVariant(id, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'ADDING…'; }
    return fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function () { return refresh(); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = 'ADD'; } })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'ADD'; } });
  }

  /* ---- open / close ---- */
  function open() {
    // Bind lazily: the markup may not have existed when this script first ran
    // (theme-editor re-render, deferred section, etc).
    if (!bind()) { window.location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refresh();
    var close = root.querySelector('[data-cd-close]');
    if (close) close.focus();
  }
  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var bound = false;
  function bind() {
    if (bound) return true;
    root = document.querySelector('[data-cart-drawer]');
    if (!root) return false;
    bound = true;

    cartUrl = root.getAttribute('data-cart-url') || '/cart';
    changeUrl = root.getAttribute('data-change-url') || '/cart/change';
    addUrl = root.getAttribute('data-add-url') || '/cart/add';
    moneyFormat = root.getAttribute('data-money-format') || '';
    shipGoal = parseInt(root.getAttribute('data-ship-goal'), 10) || 0;
    bundleQty = parseInt(root.getAttribute('data-bundle-qty'), 10) || 0;
    bundleGate = root.getAttribute('data-bundle-gate') === 'true';
    bundlePrice = parseInt(root.getAttribute('data-bundle-price'), 10) || 0;
    bundleCode = root.getAttribute('data-bundle-code') || '';
    bundleLabel = root.getAttribute('data-bundle-label') || '';
    if (!bundleLabel) bundleLabel = bundleQty + ' for ' + fmt(bundlePrice * 100);
    recUrl = root.getAttribute('data-rec-url') || '';
    upsellMode = root.getAttribute('data-upsell-mode') || 'auto';
    upsellLimit = parseInt(root.getAttribute('data-upsell-limit'), 10) || 6;
    var staticRow = root.querySelector('.cd__upsell-row');
    if (staticRow) staticHtml = staticRow.innerHTML;
    qualType = root.getAttribute('data-product-type') || '';
    qualVariant = (root.getAttribute('data-bundle-variant') || '').trim().toLowerCase();
    var ids = root.getAttribute('data-qualifying-ids') || '';
    qualIds = ids ? ids.split(',').filter(Boolean) : [];

    root.querySelectorAll('[data-cd-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    // Delegated — items and upsell cards are re-rendered on every change
    root.addEventListener('click', function (e) {
      var up = e.target.closest ? e.target.closest('[data-cd-up-add]') : null;
      if (up) { addVariant(up.getAttribute('data-variant-id'), up); return; }

      var itemEl = e.target.closest ? e.target.closest('.cd-item') : null;
      if (!itemEl || !state) return;
      var line = parseInt(itemEl.getAttribute('data-line'), 10);
      var item = state.items[line - 1];
      if (!item) return;

      if (e.target.closest('[data-cd-plus]')) changeLine(line, item.quantity + 1, itemEl);
      else if (e.target.closest('[data-cd-minus]')) changeLine(line, Math.max(0, item.quantity - 1), itemEl);
      else if (e.target.closest('[data-cd-remove]')) changeLine(line, 0, itemEl);
    });

    return true;
  }

  function init() {
    bind();

    // Registered unconditionally so an add still reaches the drawer even if the
    // markup was not in the DOM at this point.
    document.addEventListener('havmi:cart:added', function () { open(); });
    document.querySelectorAll('.header__cart').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });

    window.HavmiCart = { open: open, close: close, refresh: refresh };
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-toggle"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFT(root) {
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-ft-opt]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ft-panel]'));
    var pill = root.querySelector('[data-ft-pill]');

    function positionPill() {
      var active = root.querySelector('[data-ft-opt].is-active');
      if (!pill || !active) return;
      pill.style.width = active.offsetWidth + 'px';
      pill.style.transform = 'translateX(' + active.offsetLeft + 'px)';
    }
    function visiblePanel() {
      for (var i = 0; i < panels.length; i++) { if (!panels[i].hidden) return panels[i]; }
      return null;
    }
    function updateActiveDot(panel) {
      var row = panel.querySelector('[data-ft-row]');
      var dots = panel.querySelectorAll('.ft__dot');
      if (!row || !dots.length) return;
      var idx = Math.round(row.scrollLeft / row.clientWidth);
      if (idx < 0) idx = 0;
      if (idx > dots.length - 1) idx = dots.length - 1;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function buildDots(panel) {
      if (!panel) return;
      var row = panel.querySelector('[data-ft-row]');
      var dotsWrap = panel.querySelector('[data-ft-dots]');
      if (!row || !dotsWrap) return;
      var cw = row.clientWidth;
      dotsWrap.innerHTML = '';
      if (!cw) return;
      var pages = Math.ceil((row.scrollWidth - 1) / cw);
      if (pages <= 1) return;
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ft__dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Page ' + (i + 1));
        (function (idx) {
          b.addEventListener('click', function () { row.scrollTo({ left: idx * cw, behavior: 'smooth' }); });
        })(i);
        dotsWrap.appendChild(b);
      }
      updateActiveDot(panel);
    }

    panels.forEach(function (panel) {
      var row = panel.querySelector('[data-ft-row]');
      if (!row) return;
      var t;
      row.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { updateActiveDot(panel); }, 60);
      }, { passive: true });
    });

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        var id = opt.getAttribute('data-ft-opt');
        opts.forEach(function (o) {
          var active = o === opt;
          o.classList.toggle('is-active', active);
          o.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-ft-panel') !== id; });
        positionPill();
        buildDots(visiblePanel());
      });
    });

    // AJAX add-to-cart
    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    root.querySelectorAll('[data-atc-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-atc]');
        var original = btn.textContent;
        var id = form.querySelector('[name="id"]').value;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetch(cartUrl + '.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            // Hand off to the cart drawer (sections/cart-drawer.liquid)
            try {
              if (window.HavmiCart && window.HavmiCart.open) {
                window.HavmiCart.open();
              } else {
                // Drawer section is not on the page — still get the customer to a cart,
                // and say why in the console instead of failing silently.
                console.warn('[Havmi] Cart drawer not found. Upload sections/cart-drawer.liquid and layout/theme.liquid.');
                window.location.href = cartUrl;
              }
            } catch (err) {
              console.error('[Havmi] Cart drawer failed to open:', err);
              window.location.href = cartUrl;
            }
            btn.textContent = 'Added ✓';
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
          })
          .catch(function () { btn.disabled = false; btn.textContent = original; form.submit(); });
      });
    });

    positionPill();
    buildDots(visiblePanel());
    window.addEventListener('resize', function () { positionPill(); buildDots(visiblePanel()); });
    window.addEventListener('load', positionPill);
  }
  function init() { document.querySelectorAll('[data-ft]').forEach(initFT); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-footer-nav]').forEach(function (nav) {
      var toggles = nav.querySelectorAll('[data-footer-toggle]');
      toggles.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-footer-toggle');
          var panel = nav.querySelector('[data-footer-panel="' + key + '"]');
          var open = btn.getAttribute('aria-expanded') !== 'true';

          // One group at a time, so the footer never grows into a wall of links.
          toggles.forEach(function (other) { other.setAttribute('aria-expanded', 'false'); });
          nav.querySelectorAll('[data-footer-panel]').forEach(function (p) { p.hidden = true; });

          if (open && panel) {
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      });
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  function init() {
    var drawer = document.getElementById('MobileDrawer');
    var searchPanel = document.querySelector('[data-search-panel]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var t = document.querySelector('[data-drawer-open]');
      if (t) t.setAttribute('aria-expanded', 'true');
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      var t = document.querySelector('[data-drawer-open]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }

    document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', openDrawer);
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });

    // Accordion submenus in the drawer
    document.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.drawer__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    // Animated rotating placeholder — e.g. "Search for hair care" → "Search for spices" …
    document.querySelectorAll('input[data-placeholder-words]').forEach(function (input) {
      var prefix = input.getAttribute('data-placeholder-prefix') || '';
      // The theme editor strips trailing spaces from text settings, which would
      // render "Search forDiabatone". Guarantee exactly one space before the word.
      if (prefix && !/\s$/.test(prefix)) prefix += ' ';
      var words = (input.getAttribute('data-placeholder-words') || '')
        .split(/\r?\n/)
        .map(function (w) { return w.trim(); })
        .filter(Boolean);
      if (!words.length) return; // no suggestions → keep the static placeholder

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { input.setAttribute('placeholder', prefix + words[0]); return; }

      var w = 0, c = 0, deleting = false;
      var TYPE = 90, DEL = 45, HOLD = 1500, GAP = 350;

      function tick() {
        var word = words[w];
        if (!deleting) {
          c++;
          input.setAttribute('placeholder', prefix + word.slice(0, c));
          if (c >= word.length) { deleting = true; setTimeout(tick, HOLD); return; }
          setTimeout(tick, TYPE);
        } else {
          c--;
          input.setAttribute('placeholder', prefix + word.slice(0, Math.max(0, c)));
          if (c <= 0) { deleting = false; w = (w + 1) % words.length; setTimeout(tick, GAP); return; }
          setTimeout(tick, DEL);
        }
      }
      input.setAttribute('placeholder', prefix);
      setTimeout(tick, 600);
    });

    // Predictive search
    var predictiveRoots = [];
    document.querySelectorAll('[data-predictive-search]').forEach(function (root) {
      var input = root.querySelector('[data-predictive-input]');
      var results = root.querySelector('[data-predictive-results]');
      var clearBtn = root.querySelector('[data-search-clear]');
      var endpoint = root.getAttribute('data-predictive-url') || '/search/suggest';
      var timer, controller;
      predictiveRoots.push({ root: root, results: results });

      function hideResults() {
        results.hidden = true;
        results.innerHTML = '';
        clearActive();
      }
      function showResults() { results.hidden = false; }
      function items() { return results.querySelectorAll('.predictive__item, .predictive__all'); }
      function clearActive() {
        items().forEach(function (el) { el.classList.remove('is-active'); });
      }

      function run(query) {
        if (controller) controller.abort();
        controller = new AbortController();
        // query = Shopify's own term completions, which is what makes the
        // dropdown suggest "shampoo" while you are still typing "shampo".
        var url = endpoint + '?q=' + encodeURIComponent(query) +
          '&resources[type]=query,product,collection' +
          '&resources[limit]=5' +
          '&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,variants.title,vendor,tag' +
          '&section_id=predictive-search';
        results.innerHTML = '<div class="search__loading">Searching…</div>';
        showResults();
        fetch(url, { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = inner ? inner.innerHTML : '';
            showResults();
          })
          .catch(function (err) { if (err.name !== 'AbortError') hideResults(); });
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (clearBtn) clearBtn.hidden = q.length === 0;
        clearTimeout(timer);
        if (q.length < 2) { hideResults(); return; }
        timer = setTimeout(function () { run(q); }, 220);
      });

      input.addEventListener('focus', function () {
        if (results.innerHTML.trim() && input.value.trim().length >= 2) showResults();
      });

      // Keyboard navigation through suggestions
      input.addEventListener('keydown', function (e) {
        var list = Array.prototype.slice.call(items());
        if (!list.length || results.hidden) return;
        var current = results.querySelector('.is-active');
        var idx = list.indexOf(current);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          clearActive();
          var next = idx + 1 >= list.length ? list.length - 1 : idx + 1;
          list[next].classList.add('is-active');
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          clearActive();
          if (idx > 0) list[idx - 1].classList.add('is-active');
        } else if (e.key === 'Enter' && current) {
          e.preventDefault();
          window.location.href = current.getAttribute('href');
        }
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          input.value = '';
          clearBtn.hidden = true;
          hideResults();
          input.focus();
        });
      }
    });

    // Collapsed search: the icon beside the cart opens the bar
    var searchToggle = document.querySelector('[data-search-toggle]');
    function setSearchOpen(open) {
      if (!searchPanel) return;
      searchPanel.classList.toggle('is-open', open);
      if (searchToggle) searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var field = searchPanel.querySelector('[data-predictive-input]');
        if (field) field.focus();
      }
    }
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        setSearchOpen(!searchPanel.classList.contains('is-open'));
      });
    }

    // Click outside closes any open results, and the collapsed bar with them
    document.addEventListener('click', function (e) {
      predictiveRoots.forEach(function (p) {
        if (!p.root.contains(e.target)) { p.results.hidden = true; }
      });
      if (searchPanel && searchPanel.classList.contains('is-open') && !searchPanel.contains(e.target)) {
        setSearchOpen(false);
      }
    });

    // Escape closes things
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeDrawer();
        setSearchOpen(false);
        predictiveRoots.forEach(function (p) { p.results.hidden = true; });
      }
    });
  }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  function initCollection(root) {
    var videos = root.querySelectorAll('[data-clp-video]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Play only what's on screen. preload="none" means nothing downloads until
    // a row is actually reached — important with one video per product.
    if (videos.length && !reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio >= 0.35) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: [0, 0.35, 0.75] });
      videos.forEach(function (v) { io.observe(v); });
    }

    // Sound toggle — only one row audible at a time.
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-clp-sound]') : null;
      if (!btn) return;
      var wrap = btn.closest('.clp-row__video');
      var vid = wrap && wrap.querySelector('[data-clp-video]');
      if (!vid) return;

      var turningOn = vid.muted;
      if (turningOn) {
        videos.forEach(function (other) {
          if (other !== vid) {
            other.muted = true;
            var ob = other.parentNode.querySelector('[data-clp-sound]');
            if (ob) { ob.setAttribute('aria-pressed', 'false'); ob.setAttribute('aria-label', 'Turn sound on'); }
          }
        });
      }
      vid.muted = !turningOn;
      btn.setAttribute('aria-pressed', turningOn ? 'true' : 'false');
      btn.setAttribute('aria-label', turningOn ? 'Turn sound off' : 'Turn sound on');
      if (turningOn) {
        var pr = vid.play();
        if (pr && pr.catch) pr.catch(function () {});
      }
    });

    // AJAX add-to-cart, handing off to the cart drawer like the other sections.
    root.addEventListener('submit', function (e) {
      var form = e.target.closest ? e.target.closest('[data-clp-atc-form]') : null;
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-clp-atc]');
      var original = btn.textContent;
      var id = form.querySelector('[name="id"]').value;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          if (window.HavmiCart && window.HavmiCart.open) {
            window.HavmiCart.open();
          } else {
            window.location.href = '/cart';
          }
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
        })
        .catch(function () { btn.disabled = false; btn.textContent = original; form.submit(); });
    });
  }

  function init() { document.querySelectorAll('[data-clp]').forEach(initCollection); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function initPDP(root) {
      var variants = [];
      try {
        variants = JSON.parse(root.querySelector('[data-pdp-variants]').textContent);
      } catch (e) {}

      var idInput = root.querySelector('[data-pdp-variant-id]');
      var priceEl = root.querySelector('[data-pdp-price]');
      var compareEl = root.querySelector('[data-pdp-compare]');
      var discountEl = root.querySelector('[data-pdp-discount]');
      var atcButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-atc], [data-pdp-sticky-atc]'));
      var atcTexts = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-atc-text]'));
      var valueBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-value]'));
      var optionEls = Array.prototype.slice.call(root.querySelectorAll('.pdp__option'));
      var savingsEl = root.querySelector('[data-pdp-savings]');
      var netQtyEl = root.querySelector('[data-pdp-netqty]');
      var netQtyValueEl = root.querySelector('[data-pdp-netqty-value]');

      var selected = optionEls.map(function (el) {
        var sel = el.querySelector('.pdp__value.is-selected');
        return sel ? sel.getAttribute('data-value') : null;
      });

      function setAtcText(txt) {
        atcTexts.forEach(function (el) {
          el.textContent = txt;
        });
      }
      function setAtcDisabled(state) {
        atcButtons.forEach(function (b) {
          b.disabled = state;
        });
      }

      // The variant Liquid already resolved into the hidden id input. Used as the
      // fallback whenever the option buttons cannot identify one on their own.
      function serverVariant() {
        var id = idInput ? String(idInput.value) : '';
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === id) return variants[i];
        }
        return variants[0];
      }

      function findVariant(opts) {
        // A product with no options (has_only_default_variant) renders no
        // .pdp__option elements, so `opts` is empty. The every() below would then
        // compare the lone "Default Title" against undefined, match nothing, and
        // render a perfectly buyable product as "Unavailable" — the whole reason
        // single-variant products could not be bought. An option that renders
        // with nothing pre-selected leaves a null slot and springs the same trap.
        // Neither case means "no such variant"; fall back to the server's pick.
        if (!opts.length || opts.indexOf(null) !== -1) return serverVariant();
        return variants.find(function (v) {
          return (
            v.options.length === opts.length &&
            v.options.every(function (o, i) {
              return o === opts[i];
            })
          );
        });
      }
      function updateAvailability() {
        valueBtns.forEach(function (btn) {
          var oi = parseInt(btn.getAttribute('data-option-index'), 10);
          var trial = selected.slice();
          trial[oi] = btn.getAttribute('data-value');
          var exists = variants.some(function (v) {
            return (
              v.available &&
              v.options.every(function (o, i) {
                return trial[i] == null || o === trial[i];
              })
            );
          });
          btn.classList.toggle('is-unavailable', !exists);
        });
      }

      /* ---- Gallery ---- */
      var stage = root.querySelector('[data-pdp-stage]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-dot]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));

      function setActiveIndex(i) {
        dots.forEach(function (d, di) {
          d.classList.toggle('is-active', di === i);
        });
        thumbs.forEach(function (t, ti) {
          t.classList.toggle('is-active', ti === i);
        });
      }
      function goToSlide(i, smooth) {
        if (!stage) return;
        stage.scrollTo({ left: stage.clientWidth * i, behavior: smooth === false ? 'auto' : 'smooth' });
        setActiveIndex(i);
      }
      if (stage) {
        var st;
        stage.addEventListener(
          'scroll',
          function () {
            clearTimeout(st);
            st = setTimeout(function () {
              setActiveIndex(Math.round(stage.scrollLeft / stage.clientWidth));
            }, 80);
          },
          { passive: true }
        );
      }
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          goToSlide(i);
        });
      });
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          goToSlide(i);
        });
      });

      /* ---- Variant render ---- */
      function render() {
        // No variant data at all (the JSON above failed to parse). Liquid already
        // rendered the correct price and Add to cart / Sold out state, so leave it
        // alone rather than disabling a product that is genuinely in stock.
        if (!variants.length) return;

        var variant = findVariant(selected);
        optionEls.forEach(function (el, i) {
          var label = el.querySelector('[data-pdp-option-selected]');
          if (label) label.textContent = selected[i] || '';
        });
        updateAvailability();

        if (!variant) {
          setAtcDisabled(true);
          setAtcText('Unavailable');
          return;
        }
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price_formatted;
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = variant.compare_formatted;
            compareEl.hidden = false;
            if (discountEl) {
              discountEl.textContent =
                Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '% OFF';
              discountEl.hidden = false;
            }
          } else {
            compareEl.hidden = true;
            if (discountEl) discountEl.hidden = true;
          }
        }
        setAtcDisabled(!variant.available);
        setAtcText(variant.available ? 'Add to cart' : 'Sold out');

        // Net quantity follows the selected pack (100 g -> 250 g), and hides itself
        // rather than showing a stale size when a variant has none.
        if (netQtyEl && netQtyValueEl) {
          if (variant.net_qty) {
            netQtyValueEl.textContent = variant.net_qty;
            netQtyEl.hidden = false;
          } else {
            netQtyEl.hidden = true;
          }
        }

        if (savingsEl) {
          if (variant.savings_formatted) {
            var msg =
              '<span class="pdp__savings-emoji">🎉</span> You save <strong>' +
              variant.savings_formatted +
              '</strong> (' +
              variant.savings_pct +
              '% off) vs buying ' +
              variant.pack_qty +
              ' singles';
            var changed = savingsEl.innerHTML !== msg;
            savingsEl.innerHTML = msg;
            savingsEl.hidden = false;
            if (changed) {
              savingsEl.classList.remove('is-in');
              void savingsEl.offsetWidth; /* restart the entrance animation */
              savingsEl.classList.add('is-in');
            }
          } else {
            savingsEl.hidden = true;
            savingsEl.classList.remove('is-in');
          }
        }

        if (variant.media_id != null) {
          var idx = slides.findIndex(function (s) {
            return s.getAttribute('data-media-id') == variant.media_id;
          });
          if (idx >= 0) goToSlide(idx, false);
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      valueBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var oi = parseInt(btn.getAttribute('data-option-index'), 10);
          selected[oi] = btn.getAttribute('data-value');
          root.querySelectorAll('[data-pdp-value][data-option-index="' + oi + '"]').forEach(function (b) {
            b.classList.toggle('is-selected', b === btn);
          });
          if (btn.classList.contains('pdp__pack')) {
            btn.classList.remove('is-pop');
            void btn.offsetWidth; /* restart the pop + sweep */
            btn.classList.add('is-pop');
          }
          render();
        });
      });

      /* ---- Quantity (synced across the in-page + sticky steppers) ---- */
      var qtyInputs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-qty-input]'));
      function getQty() {
        var n = parseInt(qtyInputs[0].value, 10);
        return isNaN(n) || n < 1 ? 1 : n;
      }
      function setQty(n) {
        if (n < 1) n = 1;
        qtyInputs.forEach(function (i) {
          i.value = n;
        });
      }
      root.querySelectorAll('[data-pdp-qty-minus]').forEach(function (b) {
        b.addEventListener('click', function () {
          setQty(getQty() - 1);
        });
      });
      root.querySelectorAll('[data-pdp-qty-plus]').forEach(function (b) {
        b.addEventListener('click', function () {
          setQty(getQty() + 1);
        });
      });
      qtyInputs.forEach(function (i) {
        i.addEventListener('change', function () {
          setQty(getQty());
        });
      });

      /* ---- Add to cart (shared by in-page form + sticky button) ---- */
      var form = root.querySelector('#ProductForm');
      var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      function addToCart() {
        if (atcButtons[0] && atcButtons[0].disabled) return;
        setAtcDisabled(true);
        setAtcText('Adding…');
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: idInput.value, quantity: getQty() }] }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            return fetch(cartUrl + '.js').then(function (r) {
              return r.json();
            });
          })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            // Hand off to the cart drawer (sections/cart-drawer.liquid)
            try {
              if (window.HavmiCart && window.HavmiCart.open) {
                window.HavmiCart.open();
              } else {
                // Drawer section is not on the page — still get the customer to a cart,
                // and say why in the console instead of failing silently.
                console.warn(
                  '[Havmi] Cart drawer not found. Upload sections/cart-drawer.liquid and layout/theme.liquid.'
                );
                window.location.href = cartUrl;
              }
            } catch (err) {
              console.error('[Havmi] Cart drawer failed to open:', err);
              window.location.href = cartUrl;
            }
            setAtcText('Added ✓');
            setTimeout(function () {
              setAtcText('Add to cart');
              setAtcDisabled(false);
            }, 1600);
          })
          .catch(function () {
            setAtcDisabled(false);
            setAtcText('Add to cart');
            if (form) form.submit();
          });
      }
      if (form)
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          addToCart();
        });
      var stickyAtc = root.querySelector('[data-pdp-sticky-atc]');
      if (stickyAtc) stickyAtc.addEventListener('click', addToCart);

      /* ---- Accordions (respect each item's initial open state) ---- */
      root.querySelectorAll('[data-pdp-acc-toggle]').forEach(function (head) {
        var body = head.parentElement.querySelector('[data-pdp-acc-body]');
        var open = head.classList.contains('is-open');
        if (body) body.classList.toggle('is-open', open);
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        head.addEventListener('click', function () {
          var o = head.classList.toggle('is-open');
          head.setAttribute('aria-expanded', o ? 'true' : 'false');
          if (body) body.classList.toggle('is-open', o);
        });
      });

      /* ---- Delivery estimate checker ---- */
      var delivery = root.querySelector('[data-delivery]');
      if (delivery) {
        var dForm = delivery.querySelector('[data-delivery-form]');
        var dInput = delivery.querySelector('[data-delivery-input]');
        var dResult = delivery.querySelector('[data-delivery-result]');
        var minD = parseInt(delivery.getAttribute('data-min'), 10) || 2;
        var maxD = parseInt(delivery.getAttribute('data-max'), 10) || 3;
        var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        function fmt(dt) {
          return DOW[dt.getDay()] + ', ' + dt.getDate() + ' ' + MON[dt.getMonth()];
        }

        try {
          var saved = localStorage.getItem('havmi_pincode');
          if (saved) dInput.value = saved;
        } catch (e) {}
        dInput.addEventListener('input', function () {
          dInput.value = dInput.value.replace(/\D/g, '').slice(0, 6);
        });

        dForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var pin = (dInput.value || '').trim();
          // Valid Indian PIN: 6 digits, first digit 1-9 (no leading zero).
          if (!/^[1-9][0-9]{5}$/.test(pin)) {
            dResult.hidden = false;
            dResult.className = 'delivery__result is-error';
            dResult.textContent = 'Please enter a valid 6-digit Indian pincode.';
            return;
          }
          try {
            localStorage.setItem('havmi_pincode', pin);
          } catch (e) {}
          var now = new Date();
          var a = new Date(now);
          a.setDate(a.getDate() + minD);
          var b = new Date(now);
          b.setDate(b.getDate() + maxD);
          var range = minD === maxD ? fmt(b) : fmt(a) + ' – ' + fmt(b);
          var span = minD === maxD ? minD + ' day' : minD + '–' + maxD + ' days';
          dResult.hidden = false;
          dResult.className = 'delivery__result is-ok';
          var note = delivery.getAttribute('data-note') || '';
          dResult.innerHTML =
            '<strong>✓ Delivery available to ' +
            pin +
            '</strong>' +
            '<span>⚡ Fast delivery in ' +
            span +
            ' · Get it by <b>' +
            range +
            '</b></span>' +
            (note ? '<span class="delivery__note">' + note + '</span>' : '');
        });
      }

      render();
    }
    function init() {
      document.querySelectorAll('[data-pdp]').forEach(initPDP);
    }
    if (document.readyState !== 'loading') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ----------------------------------------------------------------------
     Shopify hands a metaobject rich-text field back as a JSON document, not
     HTML — printing it gives {"type":"root","children":[...]}. Convert that
     document to real markup. If the field is already HTML this never runs.
     ---------------------------------------------------------------------- */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function rtNode(n) {
    if (!n) return '';
    var kids = (n.children || []).map(rtNode).join('');
    switch (n.type) {
      case 'root': return kids;
      case 'paragraph': return '<p>' + kids + '</p>';
      case 'heading':
        var l = Math.min(6, Math.max(1, n.level || 2));
        return '<h' + l + '>' + kids + '</h' + l + '>';
      case 'list': return n.listType === 'ordered' ? '<ol>' + kids + '</ol>' : '<ul>' + kids + '</ul>';
      case 'list-item': return '<li>' + kids + '</li>';
      case 'link':
        return '<a href="' + esc(n.url || '#') + '"' +
          (n.target ? ' target="' + esc(n.target) + '" rel="noopener"' : '') + '>' + kids + '</a>';
      case 'text':
        var t = esc(n.value || '');
        if (n.bold) t = '<strong>' + t + '</strong>';
        if (n.italic) t = '<em>' + t + '</em>';
        return t;
      default: return kids;
    }
  }
  function renderRichText(el) {
    var raw = (el.getAttribute('data-rt') || el.textContent || '').trim();
    if (raw.indexOf('{') !== 0 || raw.indexOf('"type"') === -1) return;
    var json = raw.indexOf('=>') !== -1 ? raw.replace(/=>/g, ':') : raw;  // Ruby-hash form
    try {
      var html = rtNode(JSON.parse(json));
      if (html) { el.innerHTML = html; return; }
    } catch (e) { /* fall through */ }
    // Last resort: pull the text values out so the customer still reads prose.
    var out = [], re = /"value"\s*:\s*"((?:[^"\\]|\\.)*)"/g, m;
    while ((m = re.exec(json))) {
      try { out.push(JSON.parse('"' + m[1] + '"')); } catch (e2) { out.push(m[1]); }
    }
    if (out.length) el.innerHTML = '<p>' + out.map(esc).join(' ') + '</p>';
  }

  function init() {
    document.querySelectorAll('.faq__rte').forEach(renderRichText);

    document.querySelectorAll('[data-faq]').forEach(function (root) {
      root.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.faq__item');
          var panel = item && item.querySelector('[data-faq-panel]');
          var open = !item.classList.contains('is-open');
          item.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (panel) panel.hidden = !open;
        });
      });

      // "Read More" reveals the items held back by the display limit
      var more = root.parentElement && root.parentElement.querySelector('[data-faq-more]');
      if (!more) return;
      var label = more.querySelector('span');
      var shown = false;
      more.addEventListener('click', function () {
        shown = !shown;
        root.querySelectorAll('[data-faq-extra]').forEach(function (el) { el.hidden = !shown; });
        more.classList.toggle('is-open', shown);
        if (label) label.textContent = shown ? 'Show Less' : (more.getAttribute('data-label') || 'Read More');
      });
      if (label) more.setAttribute('data-label', label.textContent.trim());
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ---- Quick add to cart ----
     Delegated on the section root, which survives the innerHTML swap the
     recommendations fetch below performs. Binding to each button directly
     would leave the re-rendered cards dead. */
  function bindAdd(root) {
    if (root.dataset.addBound === 'true') return;
    root.dataset.addBound = 'true';
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-related-add]') : null;
      if (!btn) return;
      e.preventDefault();
      addToCart(root, btn);
    });
  }

  function addToCart(root, btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.disabled) return;

    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var label = btn.querySelector('[data-related-add-text]');
    var original = label ? label.textContent : '';

    function reset() {
      if (label) label.textContent = original;
      btn.disabled = false;
      btn.classList.remove('is-busy');
    }

    btn.disabled = true;
    btn.classList.add('is-busy');
    if (label) label.textContent = 'Adding…';

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch(cartUrl + '.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        if (label) label.textContent = 'Added ✓';
        // Hand off to the cart drawer (sections/cart-drawer.liquid).
        if (window.HavmiCart && window.HavmiCart.open) {
          window.HavmiCart.open();
        } else {
          console.warn('[Havmi] Cart drawer not found — sending to the cart page.');
          window.location.href = cartUrl;
          return;
        }
        setTimeout(reset, 1400);
      })
      .catch(function () { reset(); });
  }

  function initRelated(root) {
    bindAdd(root);
    if (root.dataset.loaded === 'true') return;
    if (root.querySelector('.related__row')) { root.dataset.loaded = 'true'; return; } // already rendered
    var base = root.getAttribute('data-url');
    var sectionId = root.getAttribute('data-section-id');
    var productId = root.getAttribute('data-product-id');
    var limit = root.getAttribute('data-limit') || 6;
    if (!base || !productId) return;
    var url = base + '?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit);
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-related]');
        if (fresh && fresh.querySelector('.related__row')) {
          root.innerHTML = fresh.innerHTML;
          root.classList.add('has-items');
        }
        root.dataset.loaded = 'true';
      })
      .catch(function () {});
  }
  function init() { document.querySelectorAll('[data-related]').forEach(initRelated); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStory(root) {
    var isMobile = function () { return window.matchMedia('(max-width: 899px)').matches; };
    root.querySelectorAll('[data-story-toggle]').forEach(function (head) {
      head.addEventListener('click', function () {
        if (!isMobile()) return; // cards stay open on desktop
        var card = head.closest('.story__card');
        var open = card.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  function init() { document.querySelectorAll('[data-story]').forEach(initStory); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reel-shop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReel(root) {
      var track = root.querySelector('[data-reel-track]');
      if (!track) return;
      var prev = root.querySelector('[data-reel-prev]');
      var next = root.querySelector('[data-reel-next]');
      var cards = track.querySelectorAll('.reel-card');

      function step() {
        var card = track.querySelector('.reel-card');
        if (!card) return track.clientWidth;
        var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap, 10) || 20;
        return card.offsetWidth + gap;
      }
      function updateArrows() {
        if (!prev || !next) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max;
      }
      function positionArrows() {
        var media = track.querySelector('.reel-card__media');
        if (media) root.style.setProperty('--arrow-top', (media.offsetTop + media.clientHeight / 2) + 'px');
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(updateArrows, 80);
      }, { passive: true });

      positionArrows();
      updateArrows();
      window.addEventListener('resize', function () { positionArrows(); updateArrows(); });
      window.addEventListener('load', positionArrows);

      // Autoplay videos only while visible
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var videos = root.querySelectorAll('[data-reel-video]');
      if (autoplay && !reduce && videos.length && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting && e.intersectionRatio >= 0.4) {
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else if (!v.paused) {
              v.pause();
            }
          });
        }, { threshold: [0, 0.4, 0.8] });
        videos.forEach(function (v) { io.observe(v); });
      }

      // ---------- Video lightbox ----------
      // Tiles play muted in the grid; the lightbox is where sound is allowed,
      // because opening it is a real user gesture and browsers require one.
      var modal = root.querySelector('[data-reel-modal]');
      var stage = root.querySelector('[data-reel-stage]');
      var infoBox = root.querySelector('[data-reel-info]');
      var lastFocus = null;

      function openModal(card) {
        var source = card && card.querySelector('[data-reel-video]');
        if (!modal || !source) return;
        lastFocus = document.activeElement;

        // Silence the grid so only the lightbox is heard.
        videos.forEach(function (v) { if (!v.paused) v.pause(); });

        stage.innerHTML = '';
        infoBox.innerHTML = '';

        var clone = source.cloneNode(true);
        clone.removeAttribute('data-reel-video'); // keep it out of the observer's list
        clone.muted = false;
        clone.controls = true;
        clone.loop = true;
        clone.setAttribute('preload', 'auto');
        stage.appendChild(clone);

        // Clone the product rather than re-render it, so the lightbox always
        // matches the tile. The add-to-cart handler is delegated, so it still fires.
        var info = card.querySelector('.reel-card__info');
        if (info) infoBox.appendChild(info.cloneNode(true));
        var buy = card.querySelector('form[data-atc-form]') || card.querySelector('.reel-atc');
        if (buy) infoBox.appendChild(buy.cloneNode(true));

        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        // Two frames: the browser needs to paint the start state before the
        // transition to .is-open can animate rather than snap.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { modal.classList.add('is-open'); });
        });

        var p = clone.play();
        // If sound-on playback is still refused, the controls are already there.
        if (p && p.catch) p.catch(function () {});

        var closeBtn = modal.querySelector('[data-reel-close]');
        if (closeBtn && closeBtn.focus) closeBtn.focus();
      }

      function closeModal() {
        if (!modal || modal.hidden) return;
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        var v = stage.querySelector('video');
        if (v) v.pause();
        setTimeout(function () {
          modal.hidden = true;
          stage.innerHTML = '';
          infoBox.innerHTML = '';
        }, 280);
        if (lastFocus && lastFocus.focus) lastFocus.focus();

        // The observer fires on intersection *changes*, so tiles paused on open
        // would stay frozen. Restart the ones still on screen.
        if (autoplay && !reduce) {
          videos.forEach(function (vid) {
            var r = vid.getBoundingClientRect();
            if (r.top < window.innerHeight && r.bottom > 0) {
              var pr = vid.play();
              if (pr && pr.catch) pr.catch(function () {});
            }
          });
        }
      }

      root.querySelectorAll('[data-reel-open]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          openModal(link.closest('.reel-card'));
        });
      });
      if (modal) {
        modal.querySelectorAll('[data-reel-close]').forEach(function (b) {
          b.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeModal();
        });
      }

      // AJAX add-to-cart — delegated so the lightbox's cloned form works too.
      var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      root.addEventListener('submit', function (e) {
        var form = e.target.closest ? e.target.closest('[data-atc-form]') : null;
        if (form) {
          e.preventDefault();
          var btn = form.querySelector('[data-atc]');
          var original = btn.textContent;
          var id = form.querySelector('[name="id"]').value;
          btn.disabled = true;
          btn.textContent = 'Adding…';
          fetch(addUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function () { return fetch(cartUrl + '.js').then(function (r) { return r.json(); }); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });

              // The lightbox sits at z-index 120 and the drawer at 90, so a drawer
              // opened over an open lightbox would be hidden behind it. Close the
              // lightbox first — this also stops its audio talking over the drawer.
              closeModal();

              // Hand off to the cart drawer (sections/cart-drawer.liquid)
              try {
                if (window.HavmiCart && window.HavmiCart.open) {
                  window.HavmiCart.open();
                } else {
                  // Drawer section is not on the page — still get the customer to a
                  // cart, and say why in the console instead of failing silently.
                  console.warn('[Havmi] Cart drawer not found. Upload sections/cart-drawer.liquid and layout/theme.liquid.');
                  window.location.href = cartUrl;
                }
              } catch (err) {
                console.error('[Havmi] Cart drawer failed to open:', err);
                window.location.href = cartUrl;
              }

              btn.textContent = 'Added ✓';
              setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
            })
            .catch(function () { btn.disabled = false; btn.textContent = original; form.submit(); });
        }
      });
    }
    function init() { document.querySelectorAll('[data-reel]').forEach(initReel); }
    if (document.readyState !== 'loading') { init(); }
    else { document.addEventListener('DOMContentLoaded', init); }
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initReel(root) {
    var track = root.querySelector('[data-reel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-reel-prev]');
    var next = root.querySelector('[data-reel-next]');
    var cards = track.querySelectorAll('.reel-card');

    function step() {
      var card = track.querySelector('.reel-card');
      if (!card) return track.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap, 10) || 20;
      return card.offsetWidth + gap;
    }
    function updateArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= max;
    }
    function positionArrows() {
      var media = track.querySelector('.reel-card__media');
      if (media) root.style.setProperty('--arrow-top', (media.offsetTop + media.clientHeight / 2) + 'px');
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(updateArrows, 80);
    }, { passive: true });

    positionArrows();
    updateArrows();
    window.addEventListener('resize', function () { positionArrows(); updateArrows(); });
    window.addEventListener('load', positionArrows);

    // Autoplay videos only while visible
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var videos = root.querySelectorAll('[data-reel-video]');
    if (autoplay && !reduce && videos.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio >= 0.4) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: [0, 0.4, 0.8] });
      videos.forEach(function (v) { io.observe(v); });
    }

    // AJAX add-to-cart
    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    root.querySelectorAll('[data-atc-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-atc]');
        var original = btn.textContent;
        var id = form.querySelector('[name="id"]').value;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetch(cartUrl + '.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            // Hand off to the cart drawer (sections/cart-drawer.liquid)
            try {
              if (window.HavmiCart && window.HavmiCart.open) {
                window.HavmiCart.open();
              } else {
                // Drawer section is not on the page — still get the customer to a cart,
                // and say why in the console instead of failing silently.
                console.warn('[Havmi] Cart drawer not found. Upload sections/cart-drawer.liquid and layout/theme.liquid.');
                window.location.href = cartUrl;
              }
            } catch (err) {
              console.error('[Havmi] Cart drawer failed to open:', err);
              window.location.href = cartUrl;
            }
            btn.textContent = 'Added ✓';
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
          })
          .catch(function () { btn.disabled = false; btn.textContent = original; form.submit(); });
      });
    });
  }
  function init() { document.querySelectorAll('[data-reel]').forEach(initReel); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spotlight-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSpotlight(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-panel') !== id;
        });
        tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      });
    });

    // AJAX add-to-cart
    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    root.querySelectorAll('[data-atc-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-atc]');
        var original = btn.textContent;
        var id = form.querySelector('[name="id"]').value;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () { return fetch(cartUrl + '.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            // Hand off to the cart drawer (sections/cart-drawer.liquid)
            try {
              if (window.HavmiCart && window.HavmiCart.open) {
                window.HavmiCart.open();
              } else {
                // Drawer section is not on the page — still get the customer to a cart,
                // and say why in the console instead of failing silently.
                console.warn('[Havmi] Cart drawer not found. Upload sections/cart-drawer.liquid and layout/theme.liquid.');
                window.location.href = cartUrl;
              }
            } catch (err) {
              console.error('[Havmi] Cart drawer failed to open:', err);
              window.location.href = cartUrl;
            }
            btn.textContent = 'Added ✓';
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
          })
          .catch(function () { btn.disabled = false; btn.textContent = original; form.submit(); });
      });
    });
  }
  function init() { document.querySelectorAll('[data-spotlight]').forEach(initSpotlight); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();
})();
